<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h4 class="text-h4 casetitle pb-3 mb-0">{{title}}</h4>
    </template>
    
    <template v-slot:leftPanel>
      <InfoTable
        :titleText="$t('database.wdg_treaty')"
        :tableContent="infoTableContent"
        :contentType="'l_legis'"
      />

      <!--Reading Options Card-->
      <LangOpts
        v-if="trans"
        class="d-print-none lside-wdgt"
        :options="['en', 'tc']"
        :curLang="$route.params.lang"
        @go_trans="go_trans($event)"
      />
    </template>

    <template v-slot:mainPanel>
      <v-divider class="mt-2"></v-divider>

      <!--loading overlay-->
      <v-skeleton-loader
        v-if="overlay"
        class="pt-4  d-print-none"
        max-width="800"
        type="paragraph@2 "
      ></v-skeleton-loader>

      <!--Treaty Content-->
      <div v-if="treaty_exists" class="treaty-content mb-16" v-html="show_hl&&$route.query.hl?content_hl:content" @click="content_clicked"></div>
      <v-alert v-else-if="!overlay"
        dense text
        type="error"
        class="mt-3 mb-4"
        icon="mdi-alert-outline  d-print-none"
      > 
        {{$t('error.page_unavailable')}}
      </v-alert>
    </template>

  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import InfoTable from '../components/InfoTable'
  import LangOpts from '../components/LangOpts'
  import DownloadWidget from '../components/DownloadWidget'
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  import scrollhelper from '@/scripts/scrollhelper'
  import highlighthelper from '@/scripts/highlighthelper'
  export default {
    name:'Treaty',
    components:{
      ThreeColumn,
      InfoTable,
      LangOpts,
      DownloadWidget
    },
    data(){
      return {
        dialog: false,
        overlay: true,
        db: '',
        neutral: '',
        date: '',
        title: '',
        show_hl: true,
        content: '',
        content_hl: '',
        doc: '',
        path: '',
        trans: false,
        category: null,
        body: null,
        inforce: false,
        treaty_exists: false,
      }
    },
    methods:{
      content_clicked: scrollhelper.content_clicked,
      go_trans(lang){
        var params = {...this.$route.params, 'lang': lang}
        this.$router.push({name: this.$route.name, params: params})
        this.get_treaty()
      },
      async get_treaty(){
        var lang = this.$route.params.lang
        var abbr = this.$route.name.startsWith('ba') ? 'hktba' : this.$route.name
        var year = this.$route.params.year
        var num = this.$route.params.num
        try {
          const res = await api.get_treaty(lang, abbr, year, num)
          this.date = datehelper.display_date(res['date'])
          this.neutral = res['neutral']
          this.trans = res['has_translation']
          this.doc = res['doc']
          this.title = res['title']
          if (res.content){
            this.content = res['content']
            if (this.$route.query.hl){
              this.content_hl = highlighthelper.hlBody(this.content, this.$route.query.hl)
            }
          }
          this.category = res['category']
          this.body = res['body']
          this.inforce = res['inforce']  // boolean
          this.db = res['db']
          this.path = this.$route.path
          //window.document.title = this.title + ' | HKLII'
          
          this.treaty_exists = true
          await this.$nextTick()
          scrollhelper.scroll_to_anchor(this.$route.hash)
        } catch(err) {
          console.error(err)
          this.treaty_exists = false
        } finally {
          this.overlay = false
        }
      },
    },
    computed:{
      paths(){
        if (this.treaty_exists){
          return  [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
            {text: this.db, disabled: false, href: this.path.split('/').splice(0,4).join('/')+'/'},
            {text: this.neutral, disabled: true}
          ]
        } else {
          return [
            {text: 'HKLII', disabled: false, href: {name: 'home'}},
            {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
          ]
        }
      },
      infoTableContent(){
        var content = [
          {name: this.$t('database.date'), value: this.date},
        ]
        if (this.neutral){
          content.push({name: this.$t('database.wdg_jdg_neutral'), value: this.neutral})
        }
        if (this.category){
          content.push({name: this.$t('database.wdg_treaty_cat'), value: this.category})
        }
        if (this.body){
          content.push({name: this.$t('database.wdg_treaty_body'), value: this.body})
        }
        return content
      }
    },
    watch:{
      '$route': function () {
        this.get_treaty()
      }
    },
    beforeMount(){
      this.get_treaty()
    },
    metaInfo(){
      return{
        title: this.title,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .treaty-content{
    width:95%;
    margin:10px auto;
    @media print{
      font-size: 9.5pt;
    }
  }

  /*******formatting for treaty*******/
  .treaty-content ::v-deep a { /* causes all footnotes to be blue at hkts/2017/1/#4*/
    color: var(--v-darkgrey-base);
  }

  .treaty-content ::v-deep section >num, .treaty-content ::v-deep paragraph >num, .treaty-content ::v-deep subparagraph >num{ 
    font-weight: 600;
    font-size: 0.95em;
     @media print{
        font-size: 9pt;
      }
  }

  /***text setting****/
  .treaty-content ::v-deep h1.article, .treaty-content ::v-deep h1{
    margin-bottom: 0.33em;
    font-size: 15pt;
    line-height: 1.33em;
  }
  .treaty-content ::v-deep h2.article, .treaty-content ::v-deep h2{
    margin-top: 1.66em;
    font-size: 13.5pt;
  }

  .treaty-content ::v-deep {
    h2.article{
      color: var(--v-navlink-base);
      margin-bottom: 0.66em;
    }
    h1.article, h1, h2.article, h2{
      @media print{
        font-size: 10.5pt;
      }
    }
  }

  .treaty-content ::v-deep crossheading, .treaty-content ::v-deep ins{
    /*ins: tc/legis/bahkg/2011/9*/
    display:block;
    font-weight: 600;
    margin-top: 2em;
  }
  .treaty-content ::v-deep paragraph, .treaty-content ::v-deep subparagraph, .treaty-content ::v-deep continued{
    display:block;
    margin-top: 0.66em;
  }
  .treaty-content ::v-deep subparagraph{
    margin-left: 3em; 
  }
  .treaty-content ::v-deep paragraph >num {
    padding-left: 1em;
    display: table-cell;
  }
  .treaty-content ::v-deep {
    paragraph > content,  paragraph > leadin,  paragraph > def {
      padding-left: 1em; 
      display: table-cell;
    }
  }
  .treaty-content ::v-deep part{
    display:block;
    margin-top: 2em;
  }

  .treaty-content ::v-deep {
    part > heading, part > num{ /* /tc/legis/bahkg/2012/4 */
      display: table-cell;
    }
  }
  .treaty-content ::v-deep num+heading{
    padding-left: 1em;
  }

  .treaty-content ::v-deep term{
    font-weight: 600;
  }

  /***spacing****/
  .treaty-content{
    line-height: 1.66em;
  }

  .treaty-content ::v-deep br + br::after{
    content: "";
    display: block;
    margin-bottom: 0.33em;
  }

  .treaty-content ::v-deep {
    h1.article + br, 
    h1+br, 
    h2.article + br, 
    h2.article + br + br, 
    p >br, hr+br{
      display: none;
    }
  }

  td, th{
    padding-right: 0.66em;
    vertical-align: top;
  }

  .treaty-content > hr{
    margin-bottom: 1em;
  }

  .treaty-content ::v-deep content + content{ /*tc/legis/bahkg/2011/9, ins not displaying as block*/
    display: block;
  }

  /***tables and diagrams***/
  .treaty-content ::v-deep table{
    font-size: 0.85em;
    margin-bottom: 2em;
    @media print{
      font-size: 8.5pt;
    }
  }

  .treaty-content ::v-deep table[style*='width']{
    min-width: 230px !important;
    width:100% !important;
  }

  /***predefined***/
  .treaty-content ::v-deep .left_indent_60{
    margin-left: 1em;
  }

  .treaty-content ::v-deep marker[role=blank-line]:after{
      content: " ";
      display: block;
      margin:1.66em 0;/* FF for instance */
      line-height:1.66em;/* chrome for instance */
    }

</style>